module.exports = __webpack_public_path__ + "img/shangxian.fe0ef166.png";